(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/redux/actions.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/redux/actions.js');
"use strict";


const _svs$tickets_giftshop = svs.tickets_giftshop.gift.giftform.cart.actiontypes,
  CART_SET_PRODUCT = _svs$tickets_giftshop.CART_SET_PRODUCT,
  CART_APPEND_PRODUCT = _svs$tickets_giftshop.CART_APPEND_PRODUCT,
  CART_REMOVE_PRODUCT_GROUP = _svs$tickets_giftshop.CART_REMOVE_PRODUCT_GROUP,
  CART_CLEAR = _svs$tickets_giftshop.CART_CLEAR,
  CART_SET_ANIMATION_COMPLETE = _svs$tickets_giftshop.CART_SET_ANIMATION_COMPLETE,
  CART_SET_ERROR = _svs$tickets_giftshop.CART_SET_ERROR,
  CART_CLEAR_ERROR = _svs$tickets_giftshop.CART_CLEAR_ERROR;
const setErrorAction = () => {
  const _svs$tickets_giftshop2 = svs.tickets_giftshop.store.getState(),
    branding = _svs$tickets_giftshop2.settings.branding;
  return {
    type: CART_SET_ERROR,
    payload: {
      branding
    }
  };
};
const clearErrorAction = () => {
  const _svs$tickets_giftshop3 = svs.tickets_giftshop.store.getState(),
    branding = _svs$tickets_giftshop3.settings.branding;
  return {
    type: CART_CLEAR_ERROR,
    payload: {
      branding
    }
  };
};
const setRenderAnimationCompleteAction = (productId, productVariation, type, skinId) => {
  const _svs$tickets_giftshop4 = svs.tickets_giftshop.store.getState(),
    branding = _svs$tickets_giftshop4.settings.branding;
  return {
    type: CART_SET_ANIMATION_COMPLETE,
    payload: {
      productId,
      productVariation,
      type,
      branding,
      skinId
    }
  };
};
const cartClearAction = () => {
  const _svs$tickets_giftshop5 = svs.tickets_giftshop.store.getState(),
    branding = _svs$tickets_giftshop5.settings.branding;
  return {
    type: CART_CLEAR,
    payload: {
      branding
    }
  };
};
const setProductAction = (productId, productVariation, type, amount, skinId) => {
  const _svs$tickets_giftshop6 = svs.tickets_giftshop.store.getState(),
    products = _svs$tickets_giftshop6.products.products,
    branding = _svs$tickets_giftshop6.settings.branding;
  svs.tickets_giftshop.store.dispatch(clearErrorAction());
  return {
    type: CART_SET_PRODUCT,
    payload: {
      productId,
      productVariation,
      type,
      amount,
      products,
      branding,
      skinId
    }
  };
};
const appendProductAction = (productId, productVariation, type, viaQueryString, skinId) => {
  const _svs$tickets_giftshop7 = svs.tickets_giftshop.store.getState(),
    _svs$tickets_giftshop8 = _svs$tickets_giftshop7.products,
    products = _svs$tickets_giftshop8.products,
    jupiterProducts = _svs$tickets_giftshop8.jupiterProducts,
    branding = _svs$tickets_giftshop7.settings.branding;
  svs.tickets_giftshop.store.dispatch(clearErrorAction());
  const productList = viaQueryString ? jupiterProducts : products;
  return {
    type: CART_APPEND_PRODUCT,
    payload: {
      productId,
      productVariation,
      type,
      products: productList,
      branding,
      skinId
    }
  };
};
const removeProductGroupAction = (productId, productVariation, type, skinId) => {
  const _svs$tickets_giftshop9 = svs.tickets_giftshop.store.getState(),
    branding = _svs$tickets_giftshop9.settings.branding;
  svs.tickets_giftshop.store.dispatch(clearErrorAction());
  return {
    type: CART_REMOVE_PRODUCT_GROUP,
    payload: {
      productVariation,
      productId,
      type,
      branding,
      skinId
    }
  };
};
svs.tickets_giftshop.gift.giftform.cart.actions = {
  cartClearAction,
  setProductAction,
  appendProductAction,
  removeProductGroupAction,
  setRenderAnimationCompleteAction,
  setErrorAction,
  clearErrorAction
};

 })(window);